import { useEffect, useState } from 'react';
import { api, ApiError } from '../shared/api';
import { Busy, ErrorMessage } from '../shared/ui';
import { useI18n } from '../shared/i18n';
type Overview = { counts: { label: string; value: number }[]; source?: string; asOf?: string };
export function Home() {
  const { t, formatNumber, formatDate } = useI18n();
  const [data, setData] = useState<Overview>();
  const [unavailable, setUnavailable] = useState(false);
  const [error, setError] = useState<unknown>();
  const [loading, setLoading] = useState(true);
  async function load() {
    setLoading(true); setError(undefined); setUnavailable(false);
    try { setData(await api<Overview>('/api/overview')); }
    catch (e) { if (e instanceof ApiError && e.status === 404) setUnavailable(true); else setError(e); }
    finally { setLoading(false); }
  }
  useEffect(() => { void load(); }, []);
  return <div className="home-view"><h1>Kombinas Ofis</h1><p>{t('Öffnen Sie einen Arbeitsbereich über das Menü. Geöffnete Vorgänge bleiben beim Wechsel erhalten.')}</p>
    <section className="overview"><header><strong>{t('Übersicht')}</strong><button onClick={() => void load()} disabled={loading}>{t('Aktualisieren')}</button></header>
      <p className="source-label">{t('Datenquelle: gemeinsamer KOMBINAS-Datenbestand')}</p>
      <ErrorMessage error={error} />
      {loading ? <Busy /> : unavailable ? <p>{t('Die Gesamtübersicht ist noch nicht verfügbar. Aktuelle Daten finden Sie in den jeweiligen Arbeitsbereichen.')}</p> : data && <><dl>{data.counts.map(c => <div key={c.label}><dt>{t(c.label)}</dt><dd>{formatNumber(c.value)}</dd></div>)}</dl>{data.asOf && <p>{t('Stand: {date}', { date: formatDate(data.asOf, { dateStyle: 'short', timeStyle: 'short' }) })}</p>}</>}
    </section><p className="muted">{t('Berichte, Druckausgaben, PDF und Kataloge sind für eine spätere Phase vorgesehen.')}</p>
  </div>;
}
